import React, { useState, useEffect } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./App.css";
import Footer from "./Footer"; // Importa el componente Footer

function App() {
  const [prompt, setPrompt] = useState("");
  const [style, setStyle] = useState("óleo");
  const [singleImage, setSingleImage] = useState(null);
  const [error, setError] = useState("");
  const [progress, setProgress] = useState(0);
  const [progressMessage, setProgressMessage] = useState("");
  const [ws, setWs] = useState(null);
  const [isGenerating, setIsGenerating] = useState(false);
  const API_BASE_URL = process.env.NODE_ENV === "development"
    ? "http://localhost:8000"  // Desarrollo
    : "https://ia.suriyaco.ar"; // Producción

  useEffect(() => {
    let websocket;

    const connectWebSocket = () => {
      websocket = new WebSocket(
        process.env.NODE_ENV === "development"
          ? "ws://localhost:8000/ws/progress/"  // Desarrollo
          : "wss://ia.suriyaco.ar/ws/progress/" // Producción
      );

      websocket.onopen = () => {
        console.log("WebSocket conectado");
        setError(""); // Limpiar errores al conectarse
      };

      websocket.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          setProgress(data.progress);
          setProgressMessage(data.message);
        } catch (e) {
          console.error("Error procesando mensaje del WebSocket:", e);
          setError("Error procesando datos del WebSocket.");
        }
      };

      websocket.onerror = (error) => {
        console.error("Error en la conexión WebSocket:", error);
        setError("Error en la conexión WebSocket.");
      };

      websocket.onclose = () => {
        console.log("WebSocket cerrado");
        setError("Conexión WebSocket cerrada. Reconectando...");
        // Intentar reconectar después de 5 segundos
        setTimeout(connectWebSocket, 5000);
      };

      setWs(websocket);
    };

    connectWebSocket();

    return () => {
      if (websocket) {
        websocket.close();
      }
    };
  }, []);

  const handleGenerateSingleImage = async () => {
    if (!prompt.trim()) {
      setError("Por favor, ingresa una descripción.");
      return;
    }

    try {
      setError("");
      setProgress(0);
      setProgressMessage("Generando imagen...");
      setSingleImage(null);
      setIsGenerating(true);

      const response = await axios.post(`${API_BASE_URL}/generate_image/`, {
        prompt: prompt.trim(),
        style: style,
      });

      setIsGenerating(false);

      if (!response.data || !response.data.image) {
        setError("No se recibió una imagen válida desde el servidor.");
        return;
      }

      setSingleImage(response.data.image);
    } catch (err) {
      console.error("Error generando la imagen:", err);
      setIsGenerating(false);
      setError(
        err.response && err.response.data
          ? `Error: ${err.response.status} - ${err.response.data.detail}`
          : "Error de red. Verifica la conexión."
      );
    }
  };

  const handleStopGeneration = async () => {
    try {
      await axios.post(`${API_BASE_URL}/stop_generation/`);
      setIsGenerating(false);
      setProgress(0);
      setProgressMessage("Proceso detenido.");
    } catch (err) {
      console.error("Error al detener el proceso:", err);
      setError("No se pudo detener la generación.");
    }
  };

  return (
    <div className="App">
      <div className="container">
        <h1 className="mt-5 text-center">Generador de Imágenes</h1>
        {error && (
          <div className="alert alert-danger text-center" role="alert">
            {error}
          </div>
        )}

        <div className="form-group mt-4">
          <label>Descripción de la imagen</label>
          <input
            type="text"
            value={prompt}
            onChange={(e) => setPrompt(e.target.value)}
            className="form-control"
            placeholder="Escribe una descripción"
          />
        </div>

        <div className="form-group mt-4">
          <label>Estilo</label>
          <select
            value={style}
            onChange={(e) => setStyle(e.target.value)}
            className="form-control"
          >
            <option value="óleo">Óleo</option>
            <option value="témpera">Témpera</option>
            <option value="pincel">Pincel</option>
          </select>
        </div>

        <div className="d-flex gap-3 mt-4">
          <button
            onClick={handleGenerateSingleImage}
            className="btn btn-primary"
            disabled={isGenerating}
          >
            <i className="bi bi-image"></i>
            <span>Generar Imagen</span>
          </button>

          <button
            onClick={handleStopGeneration}
            className="btn btn-danger"
            disabled={!isGenerating}
          >
            <i className="bi bi-stop-circle"></i>
            <span>Detener Generación</span>
          </button>
        </div>

        <div className="progress mt-4">
          <div
            className="progress-bar"
            role="progressbar"
            style={{ width: `${progress}%` }}
            aria-valuenow={progress}
            aria-valuemin="0"
            aria-valuemax="100"
          >
            {progress}% - {progressMessage}
          </div>
        </div>

        {singleImage && (
          <div className="image-gallery mt-5">
            <motion.img
              src={`data:image/png;base64,${singleImage}`}
              alt="Generated"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 1 }}
              className="img-fluid"
              style={{ borderRadius: "10px", maxWidth: "100%" }}
            />
          </div>
        )}
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default App;